import Vue from 'vue'
import Vuex from 'vuex'
//import { findKey } from '@/utils.json'

import { Source } from '@/models'
//import axios from 'axios';

import Parser from 'rss-parser';
let parser = new Parser({
  customFields: {
    item: [
      'media:content',
    ],
  }
});

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    sources: [],
    lastId: -1
  },
  mutations: {
    add(state,payload){
      let source = payload.source;
      Vue.set(state.sources,source.id,source);
      state.lastId = source.id;
    },
    setSourceLoadedArticles(state,payload){
      Vue.set(payload.source,'hasLoadedArticles',true);
    },
    setSourceActive(state,payload){
      Vue.set(payload.source,'active',payload.active);
    }
  },
  actions: {
    createAndAdd({commit,state},payload) {
      let source = new Source();
      source.name = payload.source.name;
      source.url = payload.source.url;
      source.imgtag = payload.source.imgtag;
      source.id = state.lastId+1;
      source.idChamber = payload.idChamber;
      commit('add', {source: source});
    },
    async setRSS({dispatch,commit,rootState},payload) {
      if(!payload.source.hasLoadedArticles){
        let storageName = 'rss/'+payload.source.url;
        let items = [];
        await dispatch('loadLocal', {name: storageName, expire: 60}, {root: true}).then((response) => {
          //console.log(response)
          items = response.data
        }, async () => {
          //console.log(error)
          //console.log("Load from RSS: " + payload.source.url)
          let url = rootState.corsProxy + payload.source.url;

          let feed = await parser.parseURL(url);
          items = feed.items;
          commit('saveLocal', {name: storageName, data: items}, {root: true})
        })

        if(items){
          items.forEach(item => {
            dispatch('articles/createAndAdd',{rss: item, imgtag: payload.source['imgtag'], idSource: payload.source.id}, {root: true})
          });
        }

        commit('setSourceLoadedArticles',{source: payload.source})
      }

    }
  },
  getters: {
    sourceById: (state) => (id) => {
      return state.sources.find(s => s.id == id)
    },
    sourcesByChamberId: (state) => (idChamber,active) => {
      let sources = state.sources.filter(s => s.idChamber == idChamber)
      return active ? sources.filter(s => s.active) : sources;
    },
  },
  modules: {
  }
}
